export const BREAKPOINTS = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 960,
  XL: 1200,
} as const
